import React, { useEffect, useState } from 'react';
import { Form, FloatingLabel } from 'react-bootstrap';
import RichTextEditor from '../RichTextEditor';

interface ContentFormProps {
    ticket_group_code: string;
    ticket_notes: string;
    onTicketGroupCodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onTicketNotesChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function LongStoryForm({
    ticket_group_code,
    ticket_notes,
    onTicketGroupCodeChange,
    onTicketNotesChange,
}: ContentFormProps) {


    return (
        <>
            <h2 className='mb-5 font-semibold'>Ticket Group</h2>
            <Form.Group className="mb-3" controlId="formTicketGroupCode">
                <label className='text-sm mb-2'>Ticket Group Code</label>
                <FloatingLabel controlId="floatingInput" label="Ticket Group Code" className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Ticket Group Code"
                        value={ticket_group_code}
                        className='bg-gray-200'
                        onChange={onTicketGroupCodeChange}
                    />
                </FloatingLabel>
                <label className='text-sm mb-2'>Ticket Pricing Note</label>
                <FloatingLabel controlId="floatingInput" label="Ticket Pricing Note" className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Ticket Pricing Note"
                        value={ticket_notes}
                        className='bg-gray-200'
                        onChange={onTicketNotesChange}
                    />
                </FloatingLabel>
            </Form.Group>
        </>
    );
}
